import React from 'react';

import cn from 'classnames';

import {
    AdminConversationCategory,
    useGetAdminConversationCategoryList,
} from '@entities/AdminConversationCategory';
import { Flex } from '@shared/ui';

import cls from './AdminConversationCategoriesList.module.css';
import { useAdminConversationCategoriesList } from '../lib/hooks/useAdminConversationCategoriesList';

interface AdminConversationCategoriesListProps {
    classes?: string;
}

export const AdminConversationCategoriesList = ({
    classes,
}: AdminConversationCategoriesListProps) => {
    useAdminConversationCategoriesList();

    const { data } = useGetAdminConversationCategoryList();

    return (
        <Flex
            gap={16}
            direction="column"
            className={cn(cls.AdminConversationCategoriesList, [classes])}
        >
            {data?.map((category, index) => (
                <AdminConversationCategory
                    key={category.id}
                    isFirst={index === 0}
                    isLast={index === data.length - 1}
                    category={category}
                />
            ))}
        </Flex>
    );
};
